import Pusher from "pusher-js";
import NotificationsApi from "./NotificationsApi";

class StreamEvents {
  constructor() {
    this.api = new NotificationsApi();
    this.pusher = null;
    this.pusherChannel = null;
    this.timeout = null;
  }

  listenInactivity = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.pusher.disconnect();
      this.pusher = null;
      this.pusherChannel = null;
    }, 1000 * 60 * 30); // 30 minutes
  };

  listen = async (user_id) => {
    this.listenInactivity();

    if (this.pusher) {
      return;
    }

    const response = await this.api.getToken();
    const { api_key, channel } = response.data;

    this.pusher = new Pusher(api_key, {
      cluster: "us2",
      encrypted: true,
    });

    this.pusherChannel = this.pusher.subscribe(channel);
    this.pusherChannel.bind("new-notification", (data) => {
      const event = new CustomEvent("stream-notification", { detail: data });
      window.dispatchEvent(event);
    });
  };
}

let streamEvents;
if (window.streamEvents) {
  streamEvents = window.streamEvents;
} else {
  streamEvents = new StreamEvents();
  window.streamEvents = streamEvents;
}

export default streamEvents;
